import { Button, styled } from '@mui/material';
import { I18nStore } from '@tools/i18n/store';
import { injectTSDI } from '@tools/tsdi';
import { observer } from 'mobx-react';
import * as React from 'react';

import { LoginStore } from '../login-store';

const StyledButton = styled(Button)(({ theme }) => ({
    marginTop: theme.spacing(4),
    padding: theme.spacing(2),
    width: '200px',
    [theme.breakpoints.up('md')]: {
        width: '300px'
    }
}));

export const LoginButton = observer(() => {
    const { translate } = injectTSDI(I18nStore);
    const { onSubmit, form } = injectTSDI(LoginStore);

    return (
        <StyledButton
            variant="contained"
            color="primary"
            onClick={onSubmit}
            disabled={!form.$.returnedTenantName.value}
        >
            {translate('commons.continue')}
        </StyledButton>
    );
});
